import React from "react";

const TermsAndConditions = () => {
  return (
    <div
      style={{
        padding: "20px",
        borderRadius: "8px",
        maxHeight: "70vh",
      }}
    >
      <h2
        style={{
          fontSize: "24px",
          color: "#007bff",
          marginBottom: "20px",
          fontWeight: "bold",
        }}
      >
        General Terms and Conditions
      </h2>

      <section>
        <h4 style={{ fontWeight: "bold", marginTop: "16px" }}>1. Basis of contract</h4>
        <p>
          1. All contracts concluded between the customer and the provider are governed
          exclusively by these General Terms and Conditions. The customer expressly
          acknowledges this upon registration/placement of an order.
        </p>
        <p>
          2. A customer is any natural person who enters into a legal transaction for a
          purpose that is neither commercial nor related to their independent
          professional activity.
        </p>
        <p>
          3. An entrepreneur is a natural or legal person or a partnership with legal
          capacity who, when concluding a legal transaction, acts in the exercise of
          their commercial or independent professional activity.
        </p>
        <p>4. The use of this platform is prohibited for customers who have not yet reached the age of 18.</p>
        <p>5. Marriage or partnership mediation is expressly not the subject of this contract.</p>
        <p>6. Registration is free of charge.</p>
      </section>

      <section>
        <h4 style={{ fontWeight: "bold", marginTop: "16px" }}>2. User rights and obligations</h4>
        <p>
          1. The user is solely responsible for the content of the information provided
          about themselves. They undertake to protect access to this information from
          third parties.
        </p>
        <p>2. The user undertakes to provide truthful information.</p>
        <p>
          3. The user gives assurance that they are not registering for commercial
          purposes and will not use the platform for commercial gain.
        </p>
        <p>4. The user undertakes to treat any data obtained via this platform as confidential.</p>
        <p>5. The following is prohibited when using this platform:</p>
        <ul>
          <li>harassing or threatening other persons or violating the rights of third parties</li>
          <li>distributing offensive or otherwise illegal material</li>
          <li>disseminating pornographic, racist or seditious content</li>
          <li>disseminating sexually explicit texts</li>
          <li>uploading sexually suggestive photographs</li>
          <li>advertising</li>
          <li>spreading viruses</li>
          <li>sending spam, chain letters, pyramid schemes or multi-level marketing</li>
          <li>creating fake memberships</li>
        </ul>
        <p>
          6. In the event of a violation, the provider reserves the right to block your
          profile or terminate your membership without notice. We also reserve the right
          to verify the authenticity of your profile by requesting appropriate
          documentation.
        </p>
      </section>

      <section>
        <h4 style={{ fontWeight: "bold", marginTop: "16px" }}>3. Contract term and termination of contract</h4>
        <p>1. The membership is valid for an indefinite period.</p>
        <p>2. The customer has the right to unsubscribe at any time and to stop using the service.</p>
      </section>

      <section>
        <h4 style={{ fontWeight: "bold", marginTop: "16px" }}>4. Commercial use</h4>
        <p>Entrepreneurs are prohibited from using this site for commercial purposes.</p>
      </section>

      <section>
        <h4 style={{ fontWeight: "bold", marginTop: "16px" }}>5. Limitation of liability</h4>
        <p>
          1. With the exception of injury to life, limb and health and the breach of
          essential contractual obligations (cardinal obligations), the provider shall
          only be liable for damages that are attributable to intentional or grossly
          negligent behaviour. This shall also apply to indirect consequential damages,
          such as lost profits. An essential contractual obligation is one whose
          fulfilment is essential for the proper execution of the contract and on whose
          fulfilment the contractual partner regularly relies and may rely.
        </p>
        <p>
          2. Except in cases of intentional or grossly negligent conduct or in cases of
          damage resulting from injury to life, limb or health and from the breach of
          essential contractual obligations (cardinal obligations), liability shall be
          limited to the damage typically foreseeable at the time of conclusion of the
          contract and, in all other respects, to the average damage typical for the
          contract. This also applies to indirect consequential damages such as, in
          particular, lost profits.
        </p>
        <p>
          3. The limitation of liability in the above 1. and 2. shall also apply mutatis
          mutandis in favour of the provider's employees and vicarious agents.
        </p>
        <p>4. Claims for liability under the Product Liability Act remain unaffected.</p>
      </section>

      <section>
        <h4 style={{ fontWeight: "bold", marginTop: "16px" }}>6. Inactive accounts</h4>
        <p>
          If your account has been inactive for at least 6 months, the provider may delete
          it after sending a notification email, provided that there are no data
          protection considerations to the contrary.
        </p>
      </section>

      <section>
        <h4 style={{ fontWeight: "bold", marginTop: "16px" }}>7. Final provisions</h4>
        <p>
          1. The law of the Federal Republic of Germany shall apply, excluding the
          provisions of the UN Convention on Contracts for the International Sale of
          Goods. Mandatory provisions of the country in which the customer has their
          habitual residence remain unaffected.
        </p>
        <p>
          2. The place of performance is the registered office of the provider, provided
          that the customer is a merchant.
        </p>
        <p>
          3. If the customer is a merchant, a legal entity under public law or a special
          fund under public law, or has no general place of jurisdiction in the country,
          or moves their place of residence abroad after conclusion of the contract, or
          their place of residence is unknown at the time the action is brought, the
          place of jurisdiction shall be the registered office of the provider.
        </p>
        <p>
          4. Should individual provisions of this contract be invalid or contradict
          statutory provisions, this shall not affect the remainder of the contract.
        </p>
      </section>

      <p style={{ marginTop: "24px", fontStyle: "italic" }}>
        - End of the General Terms and Conditions -
      </p>
    </div>
  );
};

export default TermsAndConditions;
